<template>
  <div id="add-order">

    <!-- no-required 会将必填去掉 -->
    <el-dialog
      size="tiny"
      class="add-order-modal no-required"
      :class="dialogClassObject"
      v-model="openModal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="modalClose"
      @open="modalOpen">

      <!-- 头部 -->
      <div class="el-dialog__header custom-header">

        <!-- 返回 -->
        <!--
          资料上传页，点击“添加申请人”直接跳转到第二步，此时不需要返回 !(wiattingForUploadAddApplicant.jumpTo === 2 && step.current === 2)
          资料上传页，无 ocr 资料商品点击“添加申请人”直接跳转到第三步，此时不需要返回 !(wiattingForUploadAddApplicant.jumpTo === 3 && step.current === 3)
          !(wiattingForUploadAddApplicant.passportOrIDcard >= 0 && currentFlow === 1)
          !isOtaOnline ota线上订单在添加申请人页面无法返回
         -->
        <div class="modal-back" v-if="step.current > 1 && !(wiattingForUploadAddApplicant.jumpTo === 2 && step.current === 2) && !(wiattingForUploadAddApplicant.jumpTo === 3 && step.current === 3) && !isOtaOnline" @click="stepBack">
          <img src="../../assets/imgs/back-gray.png">
        </div>

        <!-- 标题 -->
        <div class="tab-box">
          <div class="tab-title" v-show="step.current === 1 || step.current === 2 || step.current === 3 || step.current === 4">
            {{step.simpeTitles[step.current]}}

            <!-- 资料核对时候的总人数 -->
            <span class="people-count" v-if="step.current === 4">（共{{(!isOta ? newOrder.applicant.length : newFliggyOrder.applicant_set.length)}}人）</span>
          </div>
        </div>

        <!-- 关闭 -->
        <div class="el-dialog__headerbtn" @click="modalClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>

      <!-- 选择线上还是线下 -->
      <transition name="slide-right">
        <select-online-or-offline
          v-if="openModal"
          v-show="step.current === 1"
          :support-offline="!!product.offline"
          @offlinePostMaterial="offlinePostMaterial"
          @onlineUploadMaterial="onlineUploadMaterial"
          ></select-online-or-offline>
      </transition>

      <!-- 选择手动添加还是批量上传 -->
      <transition name="slide-right">
        <manually-or-batch-upload
          v-show="step.current === 2"
          :passportOrIDcard="passportOrIDcard"
          @manuallyAdd="manuallyAdd"
          @batchUpload="batchUpload"></manually-or-batch-upload>
      </transition>

      <!-- 添加申请人 -->
      <transition name="slide-right">
        <add-applicant
          ref="addApplicant"
          v-show="step.current === 3"
          :is-ota="isOta"
          :country-id="countryId"
          :product="product"
          :productData="productData"
          :order.sync="order"
          :submiting="uiStatus.submiting"
          :normal-or-upload="normalOrUpload"
          :files-array="filesArray"
          :ocrContentPromise="ocrContentPromise"
          :currentFlow="currentFlow"
          :hideDate="hideDate"
          :modal-close="openModal"
          :earliest-depart-date="earliestDepartDate"
          :max-item="otaItemNum"
          :ota-order-info="otaOrderInfo"
          :isImportModalShow="isImportModalShow"
          @batchUpload="batchUpload"
          @batchUploadApplicantDelete="batchUploadApplicantDelete"
          @startAddOrder="startAddOrder"
          @fileUploaded="fileUploaded"
          @importApplicantOpen="importApplicantOpen"
          ></add-applicant>
      </transition>

      <!-- 邮寄资料列表 -->
      <transition name="slide-right">
        <express-list
          v-show="step.current === 4"
          :materials="expressMaterials"
          :confirm="uiStatus.materialConfirmed"
          @showImage="showImage"
          @updateConfirm="updateConfirm"
          @beforePurchase="beforePurchase"></express-list>
      </transition>
    </el-dialog>

    <!-- 多图预览弹窗 -->
    <multi-image-preview v-model="multiImagePreviewOpen" :multiImageArray="multiImageArray"></multi-image-preview>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import { mapState, mapMutations } from 'vuex';
import _ from 'lodash';
import {
  UPDATE_OTA_ID,
  UPDATE_OTA_STORE_ID,
  RESET_OTA_ORDER,
  RESET_NEW_ORDER_DATA,
  CLREAR_NEW_ORDER_EXPRESS_LIST,
  CLEAR_NEW_ORDER_APPLICANT_MSG,
  CLEAR_NEW_FLIGGY_ORDER_APPLICANT_MSG,
  RESET_NEW_FLIGGY_ORDER_DATA,
} from '../../store/modules/order/order-mutation-types';

import addNewOrderService from '../../services/add-new-order-service';
import orderingService from '../../services/ordering-service';
import utils from '../../libs/utils';
import Order from '../../libs/order';
import uploadFileService from '../../services/upload-file-service.js';

import addApplicant from './add-applicant';
import selectOnlineOrOffline from './select-online-or-offline';
import manuallyOrBatchUpload from './manually-or-batch-upload';
import expressList from './express-list';
import Http from '../../libs/http';
import multiImagePreview from '../../components/common/multi-image-preview';

export default {
  name: 'addOrder',
  components: {
    addApplicant,
    selectOnlineOrOffline,
    manuallyOrBatchUpload,
    expressList,
    multiImagePreview,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
      required: true,
    },
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    countryId: {
      type: Number,
      required: true,
      default: 0,
    },
    countryUrl: {
      type: String,
      required: true,
      default: '',
    },
    peer: {
      type: Object,
      default() {
        return {};
      },
    },

    // 订单数据
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    hideDate: {
      type: Boolean,
      default: false,
    },
    wiattingForUploadAddApplicant: {
      type: Object,
      default() {
        return {};
      },
    },

    // 是否飞猪订单
    isOta: {
      type: Boolean,
      default: false,
    },
    // 飞猪订单最大人数
    otaItemNum: {
      type: Number,
      default: 200,
    },
    oid: {
      type: String,
      default: '',
    },
    otaOrderInfo: {
      type: Object,
      default: undefined,
    },
    from: String, // 订单来源
    // 选中的拒签无忧商品id---用于订单确认时候回显默认值
    selectedRejectProductId: [Number, String],
  },
  data() {
    return {
      openModal: this.open, // 对话框是否打开
      expressMaterials: [], // 邮寄资料清单
      peerLastOrderInfo: {}, // 用户上次下单的信息
      uiStatus: {
        submited: false, // 表单是否提交
        isOfflineSupport: !!this.product.offline, // 是否支持线下订单
        submiting: false, // 提交中
        materialConfirmed: false, // 邮寄资料已确认
      },
      step: {
        current: 1, // 当前步骤
        simpeTitles: { 1: '资料递交方式', 2: 't', 3: '上传护照添加申请人', 4: '资料核对' }, // 步骤标题
      },
      passportOrIDcard: 0, // 当前商品资料包含 ocr 情况：2 包含护照，1 不包含护照但是包含身份证，0 护照、身份证都不包含
      normalOrUpload: false, // 手动添加（false）或批量上传（true）
      filesArray: [], // 用于存储要上传的 ocr 照片
      onlineOrOffline: !!this.product.offline, // 线上还是线下
      productData: null, // 对商品资料进行过处理的商品数据
      currentFlow: 0, // 当前流程，1 线上手动添加流程；2 线上批量上传流程；3 邮寄流程（线下流程）
      ocrContentPromise: [], // 用于存储 ocr 资料识别返回的 Promise
      earliestDepartDate: '',
      isOtaOnline: false,
      multiImagePreviewOpen: false,
      multiImageArray: [],
      isImportModalShow: false, // 批量导入弹窗是否打开了
    };
  },
  computed: {
    ...mapState('order/', [
      'newOrder',
      'newFliggyOrder',
    ]),

    // 获取对话框的样式，主要是一些动画控制和普通订单第三步的时候要定高500;
    dialogClassObject() {
      return {
        'now-simple-step1': this.step.current === 1,
        'now-simple-step3': this.step.current === 3,
        'now-simple-step4': this.step.current === 4,
      };
    },
    // 是否是通用商品
    isUniversalIdentity() {
      if (this.product && this.product.material && this.product.material[0]) {
        return this.product.material[0].identity_id === 5;
      }
      if (this.productData && this.productData.material && this.productData.material[0]) {
        return this.productData.material[0].identity_id === 5;
      }
      return false;
    },
  },
  watch: {

    // 商品变了.邮寄要变化
    product: {
      handler(newProduct) {
        if (!newProduct || !newProduct.visa_product_id) return;
        this.expressMaterials = utils.materialByIndentity(newProduct);
      },
      deep: true,
    },

    // 同步外部开关操作
    open() {
      this.openModal = this.open;
    },

    otaOrderInfo(newValue) {
      if (newValue && !newValue.ota_offline) {
        this.isOtaOnline = true;
      } else {
        this.isOtaOnline = false;
      }
    },
  },
  methods: {
    ...mapMutations('order/', [
      UPDATE_OTA_ID,
      UPDATE_OTA_STORE_ID,
      RESET_OTA_ORDER,
      RESET_NEW_ORDER_DATA,
      CLREAR_NEW_ORDER_EXPRESS_LIST,
      CLEAR_NEW_ORDER_APPLICANT_MSG,
      CLEAR_NEW_FLIGGY_ORDER_APPLICANT_MSG,
      RESET_NEW_FLIGGY_ORDER_DATA,
    ]),

    // 设置对话框体的overflow
    setDialogBodyOverflow(visible) {
      // 因为不能直接使用ref引用到el-dialog__body
      this.$el.querySelector('.el-dialog__body').style.overflow = visible ? 'visible' : 'hidden';
    },

    // 打开对话框回调
    modalOpen() {
      // 重置数据为一个空的申请人和空的出行时间
      this.RESET_NEW_ORDER_DATA({
        isUniversalIdentity: this.isUniversalIdentity,
      });
      this.RESET_OTA_ORDER();
      this.RESET_NEW_FLIGGY_ORDER_DATA({
        isUniversalIdentity: this.isUniversalIdentity,
      });


      // this.getPeerLastOrderInfo();

      if (this.wiattingForUploadAddApplicant.jumpTo) {
        this.step.current = this.wiattingForUploadAddApplicant.jumpTo;
        this.passportOrIDcard = this.wiattingForUploadAddApplicant.passportOrIDcard;
        this.batchUploadElecID = this.wiattingForUploadAddApplicant.batchUploadElecID;
        this.normalOrUpload = this.wiattingForUploadAddApplicant.normalOrUpload;
        this.productData = this.wiattingForUploadAddApplicant.productData;

        this.step.simpeTitles[2] = this.passportOrIDcard === 2 ? '上传护照添加申请人' : '上传身份证添加申请人';
        this.step.simpeTitles[3] = this.wiattingForUploadAddApplicant.jumpTo === 3 ? '手动添加申请人' : '上传护照添加申请人';
      }

      // 飞猪线上订单直接跳转至填写申请人信息步骤
      if (this.otaOrderInfo && !this.otaOrderInfo.ota_offline) {
        this.isOtaOnline = true;
        this.step.current = 3;
        this.currentFlow = 2;
        this.step.simpeTitles[3] = '确认出行信息';
        this.productData = utils.deepCopy(this.product);
        this.onlineUploadMaterial();
      } else {
        this.isOtaOnline = false;
      }

    },

    // 关闭对话框回调
    modalClose() {
      this.uiStatus.submited = false;

      setTimeout(() => {

        // 关闭对话框时需要重置存储的批量上传所有数据
        this.resetBatchUploadData();

        this.step.current = 1;
        this.CLREAR_NEW_ORDER_EXPRESS_LIST();
        this.setDialogBodyOverflow(false);
        this.$emit('modalClose');
      }, 200);
    },

    // 批量导入弹窗打开了
    importApplicantOpen() {
      this.isImportModalShow = true;
    },

    // 上一步(为了动画timeout, 上面同理)
    stepBack() {

      // 批量导入弹窗需要单独处理一下。批量导入弹窗打开时，点左上角返回需要关闭该弹窗（因为该弹窗并没有计入步骤）
      if (this.isImportModalShow) {
        this.isImportModalShow = false;
        return;
      }

      this.setDialogBodyOverflow(false);

      // 如果是从手动添加申请人（线下邮寄资料进行）返回
      if (this.step.current === 3) {
        if (this.currentFlow === 3) {
          this.step.current = 1;
          return;
        } else if (this.currentFlow === 2) {
        // 如果是从上传身份证/护照添加申请人返回，需要清除保存的信息

          this.resetBatchUploadData();

        } else if (this.currentFlow === 1 && !this.hideDate && this.passportOrIDcard === 0) {
        // 线上手动添加申请人流程且是商品详情页且商品没有 ocr 资料

          this.step.current = 1;
          return;
        } else if (this.isOta) {
          this.step.current = 1;
          return;
        }
      }

      this.step.current--;

      // 如果返回后的页面是第三步（添加申请人页面），需要在动画结算后设置弹窗 overflow
      if (this.step.current === 3) {
        setTimeout(() => {
          this.setDialogBodyOverflow(true);
        }, 400);
      }
    },

    // 更新资料确认
    updateConfirm(confirm) {
      this.uiStatus.materialConfirmed = confirm;
    },

    // 线下邮寄
    // flow 办理流程，1 线上手动添加流程；2 线上批量上传流程；3 邮寄流程（线下流程）
    offlinePostMaterial(flow) {

      this.getEarliestDepartDate(1).then((res) => {
        this.earliestDepartDate = res.earliest_depart_date;

        // 设置 dialog overflow 为 false 是为了切换步骤页面时动画效果不显示到浮层外
        this.setDialogBodyOverflow(false);

        this.currentFlow = flow || 0;

        this.normalOrUpload = false;
        this.step.current = 3;

        this.step.simpeTitles[3] = '手动添加申请人';

        // 动画效果结束后，设置 dialog overflow 为 true，让日期选择控制能完整显示
        setTimeout(() => {
          this.setDialogBodyOverflow(true);
        }, 400);

      });
    },

    // 线上上传
    onlineUploadMaterial() {

      this.getEarliestDepartDate(0).then((res) => {
        this.earliestDepartDate = res.earliest_depart_date;

        this.setDialogBodyOverflow(false);

        // 遍历该商品配置的身份对应的资料
        this.productData = addNewOrderService.isHavePassportOrIDcard(this.product);
        this.passportOrIDcard = this.productData.passportOrIDcard;
        this.batchUploadElecID = this.productData.batchUploadElecID;

        // 飞猪订单只支持手动添加
        if (this.isOta) {
          if (this.isOtaOnline) {
            this.step.current = 3;
            this.currentFlow = 2;
            this.step.simpeTitles[3] = '确认出行信息';
          } else {
            this.normalOrUpload = false;
            this.step.current = 3;
            this.currentFlow = 1;
            this.step.simpeTitles[3] = '手动添加申请人';
          }
        } else {
          if (this.passportOrIDcard) {

            // 有护照或身份证时跳转到第二步“手动添加或批量上传”界面
            this.step.current = 2;
            this.step.simpeTitles[2] = this.passportOrIDcard === 2 ? '上传护照添加申请人' : '上传身份证添加申请人';
          } else {

            // 都没有时跳转到第三步
            this.normalOrUpload = false;
            this.step.current = 3;
            this.currentFlow = 1;
            this.step.simpeTitles[3] = '手动添加申请人';
          }
        }


        // 动画效果结束后进行设置，避免日期选择框被弹窗遮住一部分
        setTimeout(() => {
          this.setDialogBodyOverflow(true);
        }, 400);
      });
    },

    // 获取最早可出行日期
    getEarliestDepartDate(offline) {
      return Http.post('/sys/visa_product_earliest_depart_date_query', {
        visa_product_id: this.product.visa_product_id,
        offline,
      });
    },

    // 到邮寄资料清单
    goToExpressList() {

      if (!this.isOta) {
        // 验证时间和出行人
        if (!this.newOrder.departDate) {
          this.$message.error('请选择预计出行时间');
          return;
        }
        const isNameEmpty = this.newOrder.applicant.find(el => !el.applicant_name);
        const isIdentityEmpty = this.newOrder.applicant.find(el => !(el.identity_id >= 0));
        if (isNameEmpty) {
          this.$message.error('请将申请人信息补充完整');
          return;
        }
        if (isIdentityEmpty) {
          this.$message.error('请将申请人信息补充完整');
          return;
        }
      }

      this.step.current = 4;
      this.setDialogBodyOverflow(false);

      // 遍历商品信息的资料数组，处理数据
      if (!this.isOta) {
        this.expressMaterials = addNewOrderService.createMaterials(this.product, this.newOrder.applicant);
      } else {
        this.expressMaterials = addNewOrderService.createMaterials(this.product, this.newFliggyOrder.applicant_set, true);
      }

    },

    // 选择手动添加申请人
    manuallyAdd(flow) {
      this.setDialogBodyOverflow(false);
      this.currentFlow = flow;
      this.normalOrUpload = false;
      this.step.current = 3;
      this.step.simpeTitles[3] = '手动添加申请人';
      setTimeout(() => {
        this.setDialogBodyOverflow(true);
      }, 400);
    },
    // 护照身份证批量上传，删除申请人，
    // 处理删除申请人后，出行日期浮层被遮挡问题，
    // 设置弹窗overflow，
    batchUploadApplicantDelete() {
      if (this.filesArray.length <= 4) {
        setTimeout(() => {
          this.setDialogBodyOverflow(true);
        }, 400);
      }
    },

    // 选择批量上传（继续上传）
    batchUpload(files, flow) {

      // 解决 IE11 下 input(file) change 方法会执行两遍。第二遍时文件数组长度为 0，file 为 null
      if (!(files && files.length > 0)) return;

      this.setDialogBodyOverflow(false);
      this.currentFlow = flow;

      // 将选择的文件列表转为数组
      const filesArray = Array.from(files);

      // 上传前校验文件类型
      const typeError = filesArray.find(el => ['image/jpeg', 'image/png'].indexOf(el.type) === -1);
      if (typeError) {
        this.$message.error('仅支持 png、jpg 格式的图片');
        return;
      }

      // 将新选择的图片合并到文件数组
      this.filesArray = this.filesArray.concat(filesArray);

      // 累计图片数量不能超过 200，超出部分忽略
      if (this.filesArray.length > 200) {
        this.$message.error('每个订单最多添加200个申请人，超过部分请生成新订单');
        this.filesArray = this.filesArray.splice(0, 200);
      }

      // 读取本地文件
      const fileLoad = [];
      this.filesArray.forEach((file) => {
        if (!file.url) {
          fileLoad.push(utils.loadImage(file).then((url) => {
            file.url = url;
          }));
        }
      });

      // 用于存储上传 ocr 资料的 Promise
      Promise.all(fileLoad).then(() => {
        this.filesArray = this.filesArray.concat();

        // 上传文件
        this.filesArray.forEach((file) => {

          // 身份证、护照类型不同，类型根据 this.passportOrIDcard 判断
          // 只有没有上传识别过的文件才需要上传识别
          if (!file.uploaded) {
            this.ocrContentPromise.push(uploadFileService.uploadOcrMaterial(file, this.passportOrIDcard === 2 ? 'passport' : 'idcarda'));
          }
        });

        // 所有文件都读取后
        this.normalOrUpload = true;
        this.step.simpeTitles[3] = this.passportOrIDcard === 2 ? '上传护照添加申请人' : '上传身份证添加申请人';
        this.step.current = 3;

        // 只有上传的文件比较少时，才需要设置弹窗 overflow。这是为了解决大量上传图片引起的动画卡顿、界面显示到弹窗外问题。（大量上传图片时，性能消耗大，动画 400ms 后并不会结束）
        if (this.filesArray.length <= 4) {
          setTimeout(() => {
            this.setDialogBodyOverflow(true);
          }, 400);
        }
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 标记文件已经上传
    fileUploaded(index) {
      if (!this.filesArray[index]) return;
      this.filesArray[index].uploaded = true;
    },

    // 校验内容
    checkContent(identityID, applicantName) {
      let error = '';
      if (!this.hideDate && !(this.newOrder.departDate || this.newFliggyOrder.departDate)) {
        console.log('未选择出行时间');
        return error = '请选择预计出行时间';
      }

      const isNameEmpty = _.includes(applicantName, '');
      if (isNameEmpty) {
        console.log('申请人姓名未填写');
        return error = '申请人姓名未填写';
      }

      const isNameShort = applicantName.find(el => el.length < 2);
      if (isNameShort) {
        console.log('申请人姓名过短');
        return error = '申请人姓名过短';
      }

      if (identityID.length < applicantName.length) {
        console.log('有申请人身份未选择');
        return error = '有申请人身份未选择';
      }

      const isIdentityEmpty = _.includes(identityID, undefined);
      if (isIdentityEmpty) {
        console.log('申请人身份未选择');
        return error = '申请人身份未选择';
      }
      return error;
    },

    // 批量上传资料数据构造
    batchUploadData(identityID, applicantName, ocrContent, otaApplyID) {

      const applicant_set = [];
      let ocrType = this.passportOrIDcard === 2 ? 'passport' : 'id_card';
      if (this.isOtaOnline) {
        ocrType = 'passport';
      }
      ocrContent.forEach((el, index) => {
        applicant_set.push({});
        applicant_set[index].applicant_name = applicantName[index];
        applicant_set[index].identity_id = identityID[index];
        if (this.isOtaOnline) {
          applicant_set[index].ota_apply_id = otaApplyID[index];
        }

        if (typeof el === 'object') {
          if (el.cropped_image) {
            delete el.cropped_image;
          }
          applicant_set[index][ocrType] = el;
        }
      });
      const departDate = this.isOtaOnline ? this.newFliggyOrder.departDate.format('yyyy-MM-dd') : this.newOrder.departDate.format('yyyy-MM-dd');
      const orderParams = {
        depart_date: !this.hideDate ? departDate : undefined,
        visa_product_id: this.product.visa_product_id,
        offline: 0,
        applicant_set,
      };
      if (this.isOtaOnline) {
        orderParams.ota_sub_order_id = this.oid;
      }
      return orderParams;
    },

    // 批量上传资料开始办理
    startAddOrder(identityID, applicantName, ocrContent, isHaveApplicant, otaApplyID) {
      // 如果是线上手动添加流程且是商品详情页或者订单列表页飞猪手动添加流程
      if (this.currentFlow === 1 && !this.hideDate) {
        this.purchase();
        return;
      }

      // 如果是邮寄资料流程，这个流程接着应该跳转到邮寄资料页
      if (this.currentFlow === 3) {
        this.goToExpressList();
        return;
      }

      // 批量上传资料流程
      // 校验内容
      if (!this.isOta || this.isOtaOnline) {
        const error = this.checkContent(identityID, applicantName);
        if (error) {
          this.$message.error(error);
          return;
        }

        if (applicantName.length + (isHaveApplicant || 0) > 200) {
          this.$message.error('每个订单最多添加 200 个申请人，超过部分请生成新订单');
          return;
        }
      }


      // 设置弹窗 overflow 要放在校验内容之后，否则会出现提交后（校验不通过时）再点击日期，日期选择框会被遮住的情况
      this.setDialogBodyOverflow(false);

      // 资料上传页面添加申请
      if (this.wiattingForUploadAddApplicant.passportOrIDcard >= 0) {

        const param = {
          user_order_id: this.order.user_order_id,
        };
        if (this.uiStatus.submiting) return;
        this.uiStatus.submiting = true;

        if (this.isOta) {
          if (this.isOtaOnline) {
            param.applicant_set = [];
            identityID.forEach((el, index) => {
              param.applicant_set.push({});
              param.applicant_set[index].applicant_name = applicantName[index];
              param.applicant_set[index].identity_id = el;
              param.applicant_set[index].ota_apply_id = otaApplyID[index];
              if (ocrContent && ocrContent.length > 0 && typeof ocrContent[index] === 'object') {
                if (ocrContent[index].cropped_image) {
                  delete ocrContent[index].cropped_image;
                }
                param.applicant_set[index].passport = ocrContent[index];
              }
            });
          } else {
            param.applicant_set = this.newFliggyOrder.applicant_set;
            orderingService.fliggyOrderAddApplicant(param).then(() => {
              this.$emit('refreshApplicantList');
              this.uiStatus.submiting = false;
            }).catch((e) => {
              if (e) console.log(e);
              this.uiStatus.submiting = false;
            });
          }

        } else {
          // 线上手动添加流程
          if (this.currentFlow === 1) {
            param.applicant_set = this.newOrder.applicant.map(applicant => ({ applicant_name: applicant.applicant_name, identity_id: applicant.identity_id }));
          } else {

            // 批量上传流程
            param.applicant_set = [];
            identityID.forEach((el, index) => {
              param.applicant_set.push({});
              param.applicant_set[index].applicant_name = applicantName[index];
              param.applicant_set[index].identity_id = el;
              if (ocrContent && ocrContent.length > 0 && typeof ocrContent[index] === 'object') {
                const ocrType = this.wiattingForUploadAddApplicant.passportOrIDcard === 2 ? 'passport' : 'id_card';
                if (ocrContent[index].cropped_image) {
                  delete ocrContent[index].cropped_image;
                }
                param.applicant_set[index][ocrType] = ocrContent[index];
              }
            });
          }
          orderingService.orderAddApplicant(param).then(() => {
            this.$emit('refreshApplicantList');
            this.uiStatus.submiting = false;
          }).catch((e) => {
            if (e) console.log(e);
            this.uiStatus.submiting = false;
          });

        }

        return;
      }

      // 构建请求参数
      const orderParams = this.batchUploadData(identityID, applicantName, ocrContent, otaApplyID);

      // 订单列表页转化飞猪线上订单
      if (this.isOtaOnline) {
        addNewOrderService.addFliggyOrder(orderParams)
          .then((data) => {
            // 线上线下不一样的处理
            const allSteps = orderingService.getOrderSteps(data);
            this.$router.push(allSteps[0].routeConfig);
          })
          .catch((e) => {
            if (e) console.log(e);
            this.uiStatus.submiting = false;
          });
      } else {

        // 是否选中拒签无忧-----批量添加
        if (this.selectedRejectProductId) {
          orderParams.visa_reject_product_id = this.selectedRejectProductId;
        }

        // 商品页添加申请人
        addNewOrderService.addOrder(orderParams)
          .then((data) => {
            this.sensorLog(data);

            // 线上线下不一样的处理
            const allSteps = orderingService.getOrderSteps(data);
            this.$router.push(allSteps[0].routeConfig);
          })
          .catch((e) => {
            if (e) console.log(e);
            this.uiStatus.submiting = false;
          });
      }
    },

    // 重置批量上传数据
    resetBatchUploadData() {
      // 清除 add-applicant.vue 中保存的申请人信息
      this.$refs.addApplicant.applicantName = [];
      this.$refs.addApplicant.identityID = [];
      this.$refs.addApplicant.ocrStatus = [];
      this.$refs.addApplicant.ocrContent = [];
      this.$refs.addApplicant.discernArray = [];

      // ocr 图片、姓名、识别的 ocr 信息、ocr Promise、保存的旅客身份、识别的状态。
      this.filesArray = [];
      this.ocrContentPromise = [];
    },

    // 下单前验证
    beforePurchase(onlineOrOffline) {
      if (!this.uiStatus.materialConfirmed) {
        utils.msg.warning('请确认以上资料齐全');
      } else {
        this.purchase(onlineOrOffline);
      }
    },

    sensorLog(order) {
      // 神策监控
      sensorsdata.track('StartVisaOrderConfirm', {
        source: this.from,
        country: order.country,
        visa_product_id: order.visa_product_id,
        product_name: order.product_name,
        visa_type: order.visa_type,
        depart_date: new Date(order.depart_date),
        peer_name: this.peer.peer_name,
        user_order_id: order.user_order_id,
        applicant_num: order.applicant.length,
        offline: order.offline === 0 ? '线上' : '线下',
        user_type: '同业',
        need_online_application: Boolean(this.product.visa_application && this.product.visa_application.visa_application_id),
        need_interview: Boolean(this.product.need_interview || this.product.need_delivery),
      });
    },

    // 下单
    purchase(onlineOrOffline) {
      if (this.uiStatus.submiting) return;

      let offline = 0;
      if (onlineOrOffline && onlineOrOffline === 1) {
        offline = 1;
      }

      // 清除错误消息
      this.CLEAR_NEW_ORDER_APPLICANT_MSG();
      this.CLEAR_NEW_FLIGGY_ORDER_APPLICANT_MSG();

      this.uiStatus.submiting = true;

      // 判断是否是飞猪订单
      if (this.isOta) {
        const fliggyOrderParams = {
          ota_sub_order_id: this.oid,
          depart_date: !this.hideDate ? this.newFliggyOrder.departDate.format('yyyy-MM-dd') : undefined,
          offline,
          applicant_set: this.newFliggyOrder.applicant_set,
          source: this.from,
        };
        if (this.newFliggyOrder.applicant_set.length < this.otaItemNum) {
          let alertContent = '出行人数量小于飞猪订单商品数量，是否继续？后续仍然可以添加出行人';
          if (onlineOrOffline) {
            alertContent = '出行人数量小于飞猪订单商品数量，是否继续？后续将无法添加出行人';
          }
          this.$confirm(alertContent, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            addNewOrderService.addFliggyOrder(fliggyOrderParams)
              .then((data) => {
                const allSteps = orderingService.getOrderSteps(data);
                this.$router.push(allSteps[offline ? 1 : 0].routeConfig);
              })
              .catch((e) => {
                if (e) console.log(e);
                this.uiStatus.submiting = false;
              });
          }).catch(() => {
            this.uiStatus.submiting = false;
          });
        } else {
          addNewOrderService.addFliggyOrder(fliggyOrderParams)
            .then((data) => {
              const allSteps = orderingService.getOrderSteps(data);
              this.$router.push(allSteps[offline ? 1 : 0].routeConfig);
            })
            .catch((e) => {
              if (e) console.log(e);
              this.uiStatus.submiting = false;
            });
        }
      } else {
        const orderParams = {
          depart_date: !this.hideDate ? this.newOrder.departDate.format('yyyy-MM-dd') : undefined,
          visa_product_id: this.product.visa_product_id,
          offline,
          applicant_set: this.newOrder.applicant.map(applicant => ({ applicant_name: applicant.applicant_name, identity_id: applicant.identity_id })),
          source: this.from,
        };

        // 是否选中拒签无忧------手动添加
        if (this.selectedRejectProductId) {
          orderParams.visa_reject_product_id = this.selectedRejectProductId;
        }

        addNewOrderService.addOrder(orderParams)
          .then((data) => {

            // 其实这行应该使用vuex替换掉,先放着
            utils.extend(Order, data);

            this.sensorLog(data);

            // 线上线下不一样的处理
            const allSteps = orderingService.getOrderSteps(data);
            this.$router.push(allSteps[offline ? 1 : 0].routeConfig);
          })
          .catch((e) => {
            if (e) console.log(e);
            this.uiStatus.submiting = false;
          });
      }
    },

    // 打开多图预览弹窗
    showImage(data) {
      this.multiImagePreviewOpen = true;

      // 后端部分接口资料样例 sample 返回的仍然是字符串，而不是数组，这里先做一个兼容处理。
      if (typeof data === 'string') {
        const buildData = [];
        buildData.push(data);
        this.multiImageArray = buildData;
      } else {
        this.multiImageArray = data;
      }
    },
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";

#add-order {
  .add-order-modal {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-dialog__header {
      display: none;
    }

    .el-dialog__header.custom-header {
      display: block;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      position: absolute;
      display: flex;
      left: 0;
      top: 0;
      right: 0;
      border-bottom: 1px solid #eee;

      .people-count {
        font-size: 12px;
      }

      .modal-back {
        position: absolute;
        left: 20px;
        top: 0;
        width: 31px;
        margin-left: -10px;
        cursor: pointer;

        img {
          vertical-align: text-bottom;
        }
      }
    }
    .el-dialog {
      width: 680px;
      border-radius: 5px;
      top: 0 !important;
      position: relative;
      left: auto;
      top: auto;
      margin: 0;
      transform: none;
    }

    .tab-box {
      display: flex;
      flex: 1;
      justify-content: center;
      .tab-title {
        // width: 120px;
        font-size: 16px;
        color: #2F333D;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        user-select: none;
        &.active {
          font-weight: 600;
          color: @main;
          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: @main;
          }
        }
        &.step2 {
          width: auto;
        }
      }
    }

    .el-dialog__body {
      padding: 50px 50px 30px 50px;
      position: relative;
      // min-height: 380px;
    }

    .el-form-item__label {
      padding-right: 25px;
      text-align: left;
    }
    .el-dialog__title {
      font-weight: 500;
    }
    .slide-right-enter-active {
      transition: all 400ms ease;
    }
    .slide-right-enter {
      transform: translateX(100%);
    }
    .slide-right-leave-active {
      display: none;
    }
    .slide-right-leave-to {
      display: flex;
    }
    .el-dialog__close {
      position: absolute;
      right: 20px;
      top: 16px;
      width: 19px;
      height: 19px;
      transform: rotateZ(45deg);
      cursor: pointer;

      &::before {
        content: "";
        display: block;
        width: 19px;
        position: absolute;
        top: 9px;
        left: 0;
        border-top: 1px solid #777;
      }

      &::after {
        content: "";
        display: block;
        height: 19px;
        position: absolute;
        top: 0;
        left: 9px;
        border-left: 1px solid #777;
      }

      &:hover {
        &::before,
        &::after {
          border-color: @main;
        }
      }
    }
    /* &.now-simple-step3 {
      .el-dialog__body {
        height: 500px;
      }
    } */
    &.now-simple-step1 {
      .el-dialog__body {
        padding: 50px 30px 30px 30px;
        // max-height: 540px;
      }
    }
    /* &.now-ota-step2 {
      .el-dialog__body {
        min-height: 620px;
      }
    } */
    &.now-simple-step4 {
      .el-dialog__body {
        min-height: 380px;
        overflow: auto!important;
      }
    }
    .success-added-ota-order {
      width: 680px;
      margin-left: -50px;
      .success-tips {
        height: 76px;
        background-color: rgba(94, 155, 225, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: @main;
        img {
          margin-right: 20px;
          width: 36px;
          height: 36px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/add-order.vue